import React from 'react'

import './index.css'

const FallBack = () => <div className='suspenseFallback'>Loading...</div>

export default FallBack
